$(document).ready(function () {
    if($('.welleasy-homepage-brands-slider').length > 0){
        $('.welleasy-homepage-brands-slider').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 2,
            autoplay: true,
            dots: false,
            slideTransition: 'linear',
            autoplayTimeout: 3000,
            autoplaySpeed: 0,
            speed: 5000,
            loop: 'loop',
            cssEase: 'linear',
            arrows: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: true,
                        dots: false
                    }
                }
            ]
        });
    }


    if($('.product_slider').length > 0){
        $('.product_slider').slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            infinite: false,
            dots: true,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.brand_slider').length > 0){
        $('.brand_slider').slick({
            slidesToShow: 6,
            slidesToScroll: 6,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.welleasy-testimonial-slider').length > 0){
        $('.welleasy-testimonial-slider').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 940,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.membership-work-slider').length > 0){
      console.log( "///////////////////////////////////////// CUSTOMER JS Running" )
        $('.membership-work-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            autoplay: false,
            autoplaySpeed: 4000,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 940,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true
                    }
                }
            ]
        });
    }

    if($('.diet_slider').length > 0){
        $('.diet_slider').slick({
            slidesToShow: 6,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        arrows: false,
                        dots: true
                    }
                }

            ]
        });
    }

    var filtered = false;

    $('.js-filter').on('click', function () {
        if (filtered === false) {
            $('.diet_slider').slick('slickFilter', ':even');
            $(this).text('Unfilter Slides');
            filtered = true;
        } else {
            $('.diet_slider').slick('slickUnfilter');
            $(this).text('Filter Slides');
            filtered = false;
        }
    });

    if ($('.refer-popup-HTML').length > 0){
        if (!localStorage.getItem("referFriendPopup")){
            var referPopupHTML = $('.referFriend-popup').html();
            localStorage.setItem("referFriendPopup", referPopupHTML);
            $('.refer-popup-HTML').html(localStorage.getItem("referFriendPopup"));
            $(".refer-popup-HTML .modal_popup").addClass("show-modal");
        }
    }
    var closeButton = document.querySelector(".close-button");
    if(closeButton){
        closeButton.addEventListener("click", function(){
            $(".refer-popup-HTML .modal_popup").removeClass("show-modal");
        });
    }
    $(document).mouseup(function (e) {
        let selectedBody = $(".modal-content");
        if (!selectedBody.is(e.target) && selectedBody.has(e.target).length === 0) {
            $("body").removeClass("modal-popup_open");
            $(".modal_popup.show-modal").removeClass("show-modal");
        }
    });
});


